import mori from 'mori';
import {
  kffIsNumber,
  numberPrecision,
  getPrecision,
} from '../util/util';
import { saveAs } from 'file-saver';
import { appDefault } from '../config/config';

export function processCellCallback(columnDefs) {
  const defs = mori.toJs(columnDefs).reduce((prev, curr) => {
    prev[curr.headerGroup ?
      `${curr.headerGroup}__${curr.characteristic}` :
      curr.characteristic] = curr;
    return prev;
  }, {});

  return (params) => {
    const colId = params.column.colId.replace(/^[0-9]{4}-/g, '');
    const colDef = Object.assign({}, {
      // Defaults to prevent undefined issues
      type: '',
      Precision: '',
      Suffix: '',
    }, defs[colId]);

    let value = params.value.text;
    const precision = getPrecision(colDef);

    if (appDefault.dataNotAvailable.indexOf(value) > -1 ||
      params.column.colId === 'Location') {
      return escapeNewLines(
        attachFootnotes(escapeCSVQuotes(value), params)
      );
    }

    if (colDef.type === 'percent') {
      // 2 Additional places are added to account for the decimal
      // place difference between raw and formatted percent values.
      const percentPrecision = precision === 0 && value < 0.1 ?
        2 : precision + 2;
      if (!kffIsNumber(value)) {
        return escapeNewLines(
          attachFootnotes(escapeCSVQuotes(value), params)
        );
      }
      value = numberPrecision(value, percentPrecision, false)
        .toFixed(percentPrecision);
    } else if (colDef.Precision) {
      value = numberPrecision(
        value,
        getPrecision(colDef),
        false
      );
    }

    if (colDef.type === 'currency' && !isNaN(value)) {
      return escapeNewLines(
        attachFootnotes(
          `$${escapeCSVQuotes(
            numberPrecision(value, precision, false).toFixed(precision)
          )}`, params
        )
      );
    }

    if (colDef.Suffix) {
      value = value + colDef.Suffix;
    }

    return escapeNewLines(attachFootnotes(escapeCSVQuotes(value), params));
  };
}

// export function processHeaderCallback() {
//   return ({ column }) => colId)}
//   //   return params.column.colId
//   //     .replace('__', '\n')
//   //     .replace(/^([0-9]{4})-(.*)/, '$1\n$2');
//   // };
// }

/**
 * Attach footnotes to each applicable cell... yay!
 * @param  {string} value  cell value
 * @param  {object} params ag grid params object
 * @return {string}        string with footnotes attached (if applicable)
 */
function attachFootnotes(value, params) {
  if (params.api.footnoteCallback) {
    const { data, group, child, text } = params.value;
    const context = (data.Location && 'Location')
      || params.api.baseColumnContext
      || 'State';
    const key = [
      data[context],
      (child !== false) ? ([group, child]) : group,
    ];

    if (data[context] && params.api.isMultiGeo) {
      key.push(`${text}`);
    }

    const footnotes = params.api.footnoteCallback(key)
      .map(({ label }) => label);

    if (footnotes.length > 0) {
      return `${value}#!#${footnotes.join(',')}#!#`;
    }
    return value;
  }
}

/**
 * Clean up and modify the CSV as needed
 * @param  {string} csv csv string
 * @return {[type]}     [description]
 */
export function cleanCSV(csv) {
  // Split csv on new line
  // Iterate through each line
  // check line for existance of `#!#`
  // if has existance, split on `#!#`
  // take split into two array
  // dedupe second, prepend to end of first with a `,`
  // join('')
  return csv.split('\n')
    .map((line, idx) => {
      // headers are the 3rd row
      if (idx === 2) {
        return `${
          line.replace(/^([0-9]{4})-(.*)/g, '$1\n$2')
            .slice(0, -1) // remove `\n` at end of line
        },Footnotes`;
      }
      if (line.match(/#!#/g) !== null) {
        const [data, notes] = splitArray(line.split('#!#'));
        const footnotes = notes
          .reduce((prev, note) => prev.concat(note.split(',')), [])
          .filter((note, key, self) => self.indexOf(note) === key) // dedup
          .sort((a, b) => a - b) // sort
          .join(', ');
        return `${data.join('').slice(0, -1)},"${footnotes}"`;
      }

      // Strip HTML tags
      return line.replace(/<[^>]+>/g, '');
    })
    .join('\n');
}

/**
 * Creator and downloader for the csv data (taken from AG-grids implimentation)
 * @param  {string} fileName [filename]
 * @param  {string} content  [content for file (csv, json, etc)]
 */
export function downloader(fileName, content) {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  saveAs(blob, fileName);
}

/**
 * Escape CSV quotes
 * @param  {string} str [string to escape]
 * @return {string}     [escaped string]
 */
export function escapeCSVQuotes(str) {
  if (typeof str !== 'string') {
    return str;
  }
  return str.replace(/"|“|”|\u201C|\u201D/g, '""');
}

/**
 * Check string for newlines, if they exist wrap in quotes
 * @param  {string} str [string to check]
 * @return {string}     [string wrapped in quotes]
 */
export function escapeNewLines(str) {
  if (typeof str !== 'string') {
    return str;
  }
  if (str.match('\n|\r')) {
    return str.replace(/(\r\n|\n|\r)/gm, ' ');
  }
  return str;
}

/**
 * Convience function for splitting an array every other item
 * @param  {array} arr array to split
 * @return {array}     2d array, first one is the evens (including 0), second is odds (not including 0)
 */
function splitArray(arr) {
  return [
    arr.filter((item, idx) => idx % 2 === 0),
    arr.filter((item, idx) => idx % 2 !== 0),
  ];
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/processTableDataForDownload.js
 **/